import PropTypes from "prop-types";
import React from "react";

const MessageFormValidate = props => {
  const { error } = props;
  return (
    <React.Fragment>
      <div className="text-danger" style={{ marginTop: "3px" }}>
        {error}
      </div>
    </React.Fragment>
  );
};

MessageFormValidate.propTypes = {
  error: PropTypes.string.isRequired,
};

MessageFormValidate.defaultProps = {
  error: "",
};

export default MessageFormValidate;
